export const FEEDBACK_QUERY = {
  UUID: "uuid",
  START_WORK: "startWork",
  /** @deprecated опечатка в ранних ссылках из писем */
  START_WORK_LEGACY: "sartWork",
} as const;

export function parseStartWorkFlag(
  startWork: string | null,
  legacyStartWork: string | null,
): boolean {
  const value = startWork ?? legacyStartWork;
  if (value == null) return false;
  if (value === "") return true;
  const normalized = value.toLowerCase();
  return normalized === "1" || normalized === "true" || normalized === "yes";
}

export function buildFeedbackTicketSearchParams(
  uuid: string,
  options?: { startWork?: boolean },
): URLSearchParams {
  const params = new URLSearchParams();
  params.set(FEEDBACK_QUERY.UUID, uuid);
  if (options?.startWork) {
    params.set(FEEDBACK_QUERY.START_WORK, "1");
  }
  return params;
}
